
import Component from 'vue-class-component';
import Vue from 'vue';
import { namespace } from 'vuex-class';
import { LoanStatement } from '@/loan/types/loan-statement';
import { LoanHelper } from '@/loan/helper';
import { SessionService } from '@/core/services/session';
import { CoreHelper } from '@/core/helper';
import { UtilHelper } from '@/util/helper';

const loanNamespace = namespace('loan');
const showStatementsForDefaultOption = 'Last 12 Months';

@Component
export default class LoanStatements extends Vue {
	public formatDate = UtilHelper.formatISOStringForDisplay;

	@loanNamespace.Getter('loanId')
	public loanId!: string;

	@loanNamespace.Getter('statementsSortedByLatest')
	private statements!: LoanStatement[];

	public statementsForModel: string = '';

	public visibleStatements: LoanStatement[] = [];

	get statementsForOptions(): string[] {
		return LoanHelper.getStatementsSelectOptions(this.statements, showStatementsForDefaultOption);
	}

	mounted(): void {
		[this.statementsForModel] = this.statementsForOptions;
		this.onShowStatementsForChange(this.statementsForModel);
	}

	public onShowStatementsForChange(value: string): void {
		this.visibleStatements = value === showStatementsForDefaultOption
			? LoanHelper.filterStatementsByLastNMonths(this.statements, 12)
			: LoanHelper.filterStatementsByYear(this.statements, value);
	}

	public async onStatementDownload(statement: LoanStatement): Promise<void> {
		CoreHelper.sendFormPostRequest({
			fields: {
				jwt: SessionService.getJWT(),
			},
			url: LoanHelper.getStatementDownloadLink(this.loanId, statement),
			target: '_blank',
		});
	}

	public async onStatementView(statement: LoanStatement): Promise<void> {
		CoreHelper.sendFormPostRequest({
			fields: {
				jwt: SessionService.getJWT(),
			},
			url: LoanHelper.getStatementViewLink(this.loanId, statement),
			target: '_blank',
		});
	}
}

